import { AxiosPromise, CancelToken } from 'axios';

import API_URLS from '@Constants/apiUrls.constants';

import axiosInstance from './axiosInstance.service';

export default {
  uploadFile: (fileData: FormData, cancelToken: CancelToken): AxiosPromise =>
    axiosInstance.post(API_URLS.UPLOADS, fileData, {
      cancelToken,
      headers: {
        'Content-Type': 'application/multipart-formdata',
      },
    }),
};
